import{S as o,d as s}from"./step-component2.js";const t=o,p=s;export{t as StepComponent,p as defineCustomElement}